/* eslint-disable @next/next/no-img-element */
import { useContext } from "react";
import { SliderBase } from "@reusejs/react";
import { useRouter } from "next/router";
import { Context, getWatermarkedImgixUrl } from "services";

const ImageAddressList = [
  {
    alt: "Industrial Bank Auction Properties",
    image: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/d8415810-1568-4391-bf71-78e6aa801dce?fit=fill&auto=format`,
    ),
  },
  {
    alt: "Auction Bunglow at sale",
    image: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/ed6dacf8-d679-473f-aebf-d9851217a66a?fit=fill&auto=format`,
    ),
  },
  {
    alt: "Agricultural Land auction property for sale",
    image: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/bd2ee30d-e1f4-4912-92c7-c2ecb1781792?fit=fill&auto=format`,
    ),
  },
  {
    alt: "Commercial Bank Auction Properties",
    image: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/677c9af2-e9c1-4cfa-939a-d8179814ff53?fit=fill&auto=format`,
    ),
  },
  // {
  //   alt: "Commercial Bank Auction Properties",
  //   image: "/aggricultureImage.png",
  // },
  // {
  //   alt: "Commercial Bank Auction Properties",
  //   image: "/investSection2.png",
  // },
  // {
  //   alt: "Commercial Bank Auction Properties",
  //   image: "/property_1.png",
  // },
];

const HomeSlider = (props: any) => {
  const imageList = props.allBanners?.map((banner: any, index: number) => {
    return (
      <div key={index} className="w-full h-full">
        <img
          alt={"Residentials Bank Auction Properties"}
          // onClick={() => {
          //   searchForm.setField("asset_type", "");
          //   searchForm.setField("sub_asset_type", "");
          //   router.push(item.link);
          // }}
          className="h-screen w-full object-fit"
          src={banner?.attributes?.image?.data?.attributes?.formats?.large?.url}
        />
      </div>
    );
  });

  const CONTENT2 = ImageAddressList.map((item: any, index) => {
    return (
      <div key={index} className="w-full h-full">
        <img
          alt={item.alt}
          // onClick={() => {
          //   searchForm.setField("asset_type", "");
          //   searchForm.setField("sub_asset_type", "");
          //   router.push(item.link);
          // }}
          className="h-screen w-full object-fit"
          src={item.image}
        />
      </div>
    );
  });

  return (
    <div className="z-50 h-full overflow-hidden">
      <SliderBase
        autoPlay={true}
        interval={5000}
        hideArrows={true}
        dotColors="dark"
      >
        {imageList.length > 0 ? imageList : CONTENT2}
      </SliderBase>
    </div>
  );
};

export default HomeSlider;
